import React, {useState, useEffect, useContext} from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import {
    TeamOutlined,
    UserOutlined,
    MessageOutlined,
    BarChartOutlined,
    QuestionCircleOutlined,
    EditOutlined,
    FormOutlined,
    BugOutlined,
    RiseOutlined,
    ScissorOutlined
} from '@ant-design/icons';
import { Menu, Layout, Modal, Button, Tooltip} from 'antd';
import {SideContext} from "../contexts/SideContext";
import Notify from "./Notify";
import AxiosRequest, {AxiosRequestWithImba} from "../helpers/AxiosRequest";
import {RoleContext} from "../contexts/RoleContext";

const SideBar = ({ key, location, parentValue, imba_id }) => {
    
    
    const {getSideKey, setSideKey} = useContext(SideContext);
    const [barKey, setBarKey] = useState(getSideKey());
    useEffect(() => {
        
        const interval = setInterval(()=>{
            AxiosRequestWithImba("get_message_list_count", {}, imba_id )
                    .then((data) => {
                        showCounter(data.count)
                    })
            
        },30000)
        return () => {
            clearInterval(interval)
          };
    }, [barKey])

    var href = location.pathname // Наша псевдоссылка
    var reg = href.replace(/^\/(\d+)\#?.*$/, '$1');

    const defaultKey = () => {
        let pathname = location.pathname.split('/');

        let page = pathname[pathname.length-1];
        let key = 1;
        switch (page) {
            case 'users':
                key = 2;
                break;
            case 'messages':
                key = 3;
                break;
            case 'rooms':
                key = 4;
                break;
            case 'support_new':
                key = 5;
                break;
            case 'support_work':
                key = 6;
                break;
            case 'list':
                key = 7;
                break;
             case 'list':
                key = 8;
                    break;
            case 'statitics':
                key = 9;
                break;
            case 'filter':
                key = 10;
                break;
        }
        return key;
    }
    
    const [counter, setCounter] = useState(0);
    const showCounter = (n = 0) => {
        setCounter(n);
    };
    
    

    //if(role=='admin' || role=='moderator'){
        return (
            <div>
            <Layout.Sider collapsed={true} className={'imba_sidebar'}>
                <div className="logo" />
                <Menu theme="dark" defaultSelectedKeys={[`${defaultKey()}`]} mode="inline">
                    <Menu.Item key="1" icon={<BarChartOutlined />}>
                        Statistics
                        <Link to={/^\d+$/.test(reg) ? `/${reg}` : '/'} onClick={() => setSideKey(1)}></Link>
                    </Menu.Item>
                    
                    <Menu.Item key="10" icon={<ScissorOutlined />}>
                        Filter
                        <Link to={/^\d+$/.test(reg) ? `/${reg}/filter` : '/'} onClick={() => setSideKey(10)}></Link>
                    </Menu.Item>
                    <Menu.Item key="9" icon={<RiseOutlined />}>
                        Rating
                        <Link to={/^\d+$/.test(reg) ? `/${reg}/statistics` : '/'} onClick={() => setSideKey(9)}></Link>
                    </Menu.Item>
                    
                    <Menu.Item key="2" icon={<UserOutlined />}>
                        Users
                        <Link to={/^\d+$/.test(reg) ? `/${reg}/users` : '/'} onClick={() => setSideKey(2)}></Link>
                    </Menu.Item>
                    <Menu.Item key="3" icon={<MessageOutlined />}>
                        Messages
                        <Link to={/^\d+$/.test(reg) ? `/${reg}/messages` : '/'} onClick={() => setSideKey(3)}></Link>
                    </Menu.Item>
                    <Menu.Item key="4" icon={<TeamOutlined />}>
                        Rooms
                        <Link to={/^\d+$/.test(reg) ? `/${reg}/rooms` : '/'} onClick={() => setSideKey(4)}></Link>
                    </Menu.Item>
                    <Notify count={counter}/>
                    <Menu.Item key="7" icon={<BugOutlined />}>
                        Messages with contacts
                        <Link to={/^\d+$/.test(reg) ? `/${reg}/list` : '/'} onClick={() => setSideKey(7)}></Link>
                    </Menu.Item>
                    <Menu.Item key="8" icon={<FormOutlined />}>
                        Notes
                        <Link to={/^\d+$/.test(reg) ? `/${reg}/note` : '/'} onClick={() => setSideKey(8)}></Link>
                    </Menu.Item>
                    
                    <Menu.Item key="5" icon={<QuestionCircleOutlined  />}>
                        Requests for support
                        <Link to={/^\d+$/.test(reg) ? `/${reg}/support_new` : '/'} onClick={() => setSideKey(5)}></Link>
                    </Menu.Item>
                    <Menu.Item key="6" icon={<EditOutlined />}>
                        Accepted requests
                        <Link to={/^\d+$/.test(reg) ? `/${reg}/support_work` : '/'} onClick={() => setSideKey(6)}></Link>
                    </Menu.Item>
                </Menu>
            </Layout.Sider>
            </div>
        );
    //}
    
    
}

export default withRouter(SideBar);